import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH4Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "statCard",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: [
        createH4Block({
          text: "94%",
        }),
        createPBlock({
          text: "Client satisfaction rate",
        }),
      ],
    },
  },
};
